module.exports = __webpack_public_path__ + "static/media/buy-ticket-blue.b0ba6235.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/buy-ticket-blue.svg
// module id = 1655
// module chunks = 0